import { ContainerModule, interfaces } from "inversify";
import { PricesController } from "./prices.controller";

export const PRICES_MODULE_IDS = {
  PRICES_CONTROLLER: Symbol.for("PricesController"),
}

const PricesModule = new ContainerModule((bind: interfaces.Bind) => {
  bind(PRICES_MODULE_IDS.PRICES_CONTROLLER).to(PricesController).inSingletonScope();
});

export {
  PricesModule
}